import { DivideExpression } from "../../rule-engine-core/Expressions/Expressions/Math/DivideExpression";
import { ExpressionConfiguration } from "../../rule-engine-core/Expressions/ExpressionConfiguration";

export function getDivideSimpleRule() {
    let expression = new DivideExpression();
    expression.divideValue.variableName = "divideValue";
    expression.divideBy.variableName = "divideBy";
    let exp = new ExpressionConfiguration();
    exp.expression = expression;
    return exp;
}
